import { useState } from 'react';
import {
  Flex,
  Text,
  Select,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
} from '@chakra-ui/react';
import { Button, TitleText } from 'components';
import { jobStatuses } from 'utils';

type UpdateAgencyStatusProps = {
  data: AssignmentData;
  close: () => void;
  updateAction: (status: JobStatus) => void;
};

const UpdateAgencyStatus = ({
  data,
  close,
  updateAction,
}: UpdateAgencyStatusProps): JSX.Element => {
  const [status, setStatus] = useState<JobStatus>(data.status);
  return (
    <Modal isOpen={true} onClose={close}>
      <ModalOverlay />
      <ModalContent
        alignSelf="center"
        width={['100vw', '80vw', '70vw', '60vw']}
        my={0}
        borderRadius={0}
      >
        <ModalHeader>
          <TitleText
            color="custom.levoBlack"
            text={`Update Job status for ${data?.firstname || ''} ${
              data?.lastname || ''
            }`.replace(/\s{2}/g, ' ')}
          />
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody flexGrow={1}>
          <Flex direction="column" height="100%">
            <Flex
              direction="row"
              alignItems="center"
              mr={[0, 0, 0, 4]}
              mb={[4, 4, 4, 0]}
            >
              <Text
                fontFamily="Lato"
                fontWeight={700}
                fontSize="16px"
                lineHeight="19.2px"
                mr={2}
              >
                Category:
              </Text>
              <Select
                placeholder="Select agency"
                value={status}
                onChange={(e) => {
                  setStatus(e.target.value as JobStatus);
                }}
              >
                {jobStatuses.map(({ key, title }) => (
                  <option key={key} value={title}>
                    {title}
                  </option>
                ))}
              </Select>
            </Flex>
            <Flex
              direction="column"
              alignItems="center"
              justifyContent="flex-end"
              flexGrow={1}
            >
              <Button
                width={['100%', '80%', '60%', '50%']}
                mt={4}
                mb={4}
                onClick={() => updateAction(status)}
                text="Update"
              />
            </Flex>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default UpdateAgencyStatus;
